import DateTimeService from '@app/Services/DateTimeService';

export class DateTimePickerService {
    
    static onFormatDate = (date?: Date): string => {
        return date ?  DateTimeService.toUiDate(DateTimeService.fromLocatToUtcDay(date)) : '';
    };

    static onParseDateFromString = (dateStr: string): Date | null=> {
        return dateStr ?  DateTimeService.parseUiDate(dateStr) : null;
    };
}